<div class="row">
  <h2 class="col-12"><i class="fas fa-chart-line"></i> Jumpstory Statistics</h2>
</div>

<div class="d-flex flex-column options mt-3">
  <div class="d-flex align-items-center">
    <select class="form-control" [formControl]="accountControl">
      <option value="" selected>All Accounts</option>
      <option *ngFor="let account of filteredAccounts" [value]="account.id">
        {{ account.displayName }}
      </option>
    </select>
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text"><i class="fas fa-search"></i></span>
      </div>
      <input
        placeholder="Filter accounts"
        type="text"
        class="form-control form-control-sm"
        [formControl]="filterControl"
      />
    </div>
    <span class="reset" (click)="resetFilters()">Reset filters</span>
  </div>
  <div class="d-flex">
    <select class="form-control" [formControl]="timeSpanControl">
      <option *ngFor="let timeValue of timeValues" [value]="timeValue.value">
        {{ timeValue.name }}
      </option>
    </select>
    <div
      *ngIf="timeSpanControl.value === TimeSpanType.RANGE"
      [formGroup]="rangeForm"
      class="d-flex"
    >
      <div class="input-group">
        <input
          class="form-control"
          formControlName="from"
          placeholder="From (yyyy-mm-dd)"
          ngbDatepicker
          #from="ngbDatepicker"
          (click)="from.toggle()"
        />
      </div>
      <div class="input-group">
        <input
          class="form-control"
          formControlName="to"
          placeholder="To (yyyy-mm-dd)"
          ngbDatepicker
          #to="ngbDatepicker"
          (click)="to.toggle()"
        />
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end mt-2 mb-3">
    <button class="btn btn-success" (click)="fetchStatistics()">
      Fetch Statistics
    </button>
  </div>
</div>

<ng-container>
  <app-jumpstory-statistics-table
    header="Jumpstory Statistics"
    orderBy="createdAt"
    [statistics]="statistics$ | async"
    [extraHeaders]="[
      {
        title: 'Image URL',
        prop: 'imageUrl',
        filter: true,
        size: 'small',
        clickable: true
      },
      { title: 'Date/Time', prop: 'createdAt', timestamp: true, size: 'half' }
    ]"
    (rowClick)="openJumpstoryImage($event)"
    (downloadClick)="downloadCSV()"
  ></app-jumpstory-statistics-table>
</ng-container>
